/**
 * Internal dependencies
 */
import PROJECT_ACTION from '@naruto/bgdapp/src/reducers/cores/project/events';
import {
  SetProjectContentInitialAction,
  SetProjectListAction,
  SetProjectInfoAction,
  ProjectList,
  ProjectListCondition,
  ProjectInfo
} from './types';

/* Initial */
export const SET_PROJECT_INITIALIZE = (): SetProjectContentInitialAction => ({
  type: PROJECT_ACTION.SET_PROJECT_INITIALIZE
});

/* Project Action */
export const SET_PROJECT_LIST = ({
  list,
  condition
}: {
  list: ProjectList;
  condition: ProjectListCondition;
}): SetProjectListAction => ({
  type: PROJECT_ACTION.SET_PROJECT_LIST,
  list,
  condition
});
export const SET_PROJECT_INFO = ({
  projectID,
  projectInfo
}: {
  projectID: string;
  projectInfo: ProjectInfo;
}): SetProjectInfoAction => ({
  type: PROJECT_ACTION.SET_PROJECT_INFO,
  projectID,
  projectInfo
});
